import React from "react";
import { Provider } from "react-redux";
import "./App.css";
import { store } from "./redux/store";
import DistaphoneNew from "./components/DistaphoneNew/DistaphoneNew";

const App = () => {
  return (
    <Provider store={store}>
      <div className="App">
        <DistaphoneNew />
      </div>
    </Provider>
  );
};

export default App;
